import "./RoundedCard.scss";
import { RoundedCardPropsType } from "./types";

export const RoundedCard = ({ img, label }:RoundedCardPropsType) => {
  return (
    <div className="container">
      <div className="rounded-card-container">
        <img src={img} className="img-card" alt="rounded-card-logo"></img>
      </div>
      <p>{label}</p>
    </div>
  );
};
